import { compareCaseIgnored } from 'utils/strings';
import industryTypes from 'constants/industryTypes';
import { isNullOrUndefined } from 'utils/misc';

// Standard of 10 days for NZ account and 30 for rest of the world.
export const getCancelDaysNotice = (configuredDaysNotice, country) => {
  // Zero is a valid value.
  if (!isNullOrUndefined(configuredDaysNotice)) return configuredDaysNotice;
  if (compareCaseIgnored(country.trim(), 'NZ')) return 10;
  return 30;
};

export const checkIfNzHealthAndFitness = (industryType, country) =>
  (compareCaseIgnored(industryType, industryTypes.HEALTH) ||
    compareCaseIgnored(industryType, industryTypes.FITNESS)) &&
  compareCaseIgnored(country.trim(), 'NZ');
